import { Component, Input, OnInit } from "@angular/core";
import { SafeResourceUrl, SafeValue } from "@angular/platform-browser";
import {
  NgxExtendedPdfViewerComponent,
  NgxExtendedPdfViewerModule,
} from "ngx-extended-pdf-viewer";

@Component({
  selector: "pdf-viewer",
  templateUrl: "./pdf-viewer.component.html",
  styleUrls: ["./pdf-viewer.component.scss"],

  imports: [NgxExtendedPdfViewerModule],
  standalone: true,
})
export class PdfViewerComponent implements OnInit {
  @Input() fileUrl: string;

  constructor() {
    // Don't log here - inputs are not available in constructor
  }

  ngOnInit() {
    console.log("fileUrl", this.fileUrl);
  }

  pdfLoaded() { }
}
